import React from 'react';
const Header = () => {
  return <div className="w-full bg-gray-800 text-white py-16 px-4 md:py-24" data-id="element-98">
      <div className="max-w-3xl mx-auto" data-id="element-99">
        <h1 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-100">
          Czujesz się jak widmo we własnym życiu?
        </h1>
        <h2 className="text-xl md:text-2xl mb-8" data-id="element-101">
          Badania pokazały szokującą prawdę o 2 milionach polskich matek.
        </h2>
        <div className="mb-8" data-id="element-102">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uJVotpNfBcYivCBkrb3i6k/15.png" alt="Kobieta patrząca w lustro" className="w-full rounded-lg shadow-lg" data-id="element-103" />
        </div>
        <p className="text-lg mb-4" data-id="element-104">Marta też tak się czuła. Przez 8 lat.</p>
        <p className="text-lg mb-4" data-id="element-105">
          Wszyscy dookoła mieli plany, marzenia, cele - a ona miała tylko listę
          obowiązków wobec innych.
        </p>
        <p className="text-lg mb-4" data-id="element-106">
          Aż pewnej nocy o 3:00 rano odkryła przełomowe badania dr Joanny
          Radeckiej, które ujawniły dlaczego kobiety z "pokolenia kanapkowego"
          dosłownie znikają we własnym życiu.
        </p>
        <p className="text-lg mb-4" data-id="element-107">
          I co najgorsze - dlaczego WSZYSTKIE dotychczasowe rady ("znajdź czas
          dla siebie", "zadbaj o siebie") je zawiodły.
        </p>
        <p className="text-lg font-bold italic mb-6" data-id="element-108">
          Ale to, co psychiatra pisała dalej, kompletnie przewróciło jej świat
          do góry nogami…
        </p>
      </div>
    </div>;
};
export default Header;